// @ts-nocheck
import { useAtomValue } from 'jotai';

import { alertAtom, configAtom, dcbAtom, languageAtom } from '@shared/store/slice-atoms';
import { isVariationV3Route } from '@shared/utils/general';

// Centralised state for the OTP flow. Read slice atoms directly so components
// re-render only when the slices they consume change.
export const useOTPSelectors = () => {
  const alerts = useAtomValue(alertAtom);
  const urlConfig = useAtomValue(configAtom);
  const language = useAtomValue(languageAtom);
  const dcb = useAtomValue(dcbAtom);

  const {
    homeData,
    subscribeData,
    operator,
    btnLoading,
    source,
    otpError,
    resendOtpData,
    reachedThankYou,
    operatorSelectedDetails,
    fallbackOperator,
  } = dcb;

  const isV3Route = isVariationV3Route(dcb.variationKey);

  return {
    alerts,
    urlConfig,
    language,
    homeData,
    subscribeData,
    operator,
    btnLoading,
    source,
    otpError,
    resendOtpData,
    reachedThankYou,
    operatorSelectedDetails,
    fallbackOperator,
    isV3Route,
  };
};
